
import { FC, PropsWithChildren, useMemo, useState } from 'react';

import { LoadingActionContext } from '@/contexts/layouts/LoadingActionContext';
import { LoadingContext } from '@/contexts/layouts/LoadingContext';


interface ILoadingProviderProps { }

const LoadingProvider: FC<PropsWithChildren<ILoadingProviderProps>> = ({ 
    children 
}) => {
    
    const [loading, setLoading] = useState<{ loading: boolean; validating: boolean; state: Record<string, { loading: boolean; validating: boolean; }> }>({
        loading: false, 
        validating: false,
        state: {}
    });

    const actionContext = useMemo(() => {
        return {
            setLoaded: (key: string) => {
                // Set the state loading value of the key object to false
                setLoading(c => {
                    let update = {
                        ...c,
                        state: {
                            ...c.state,
                            [key]: {
                                ...c.state[key],
                                loading: false
                            }
                        }
                    };

                    // Check if any of the key objects are loading to see if the overall state is loading
                    update.loading = Object.keys(update.state).some(x => update.state[x]?.loading === true);

                    return update;
                });
            },
            setLoading: (key: string) => {
                setLoading(c => {
                    let update = {
                        ...c,
                        state: {
                            ...c.state,
                            [key]: {
                                ...c.state[key],
                                loading: true
                            }
                        }
                    }

                    update.loading = Object.keys(update.state).some(x => update.state[x]?.loading === true);

                    return update;
                });
            },
            setValid: (key: string) => {
                setLoading(c => {
                    let update = {
                        ...c,
                        state: {
                            ...c.state,
                            [key]: {
                                ...c.state[key],
                                validating: false
                            }
                        }
                    }

                    update.validating = Object.keys(update.state).some(x => update.state[x]?.validating === true);

                    return update;
                });
            },
            setValidating: (key: string) => {
                setLoading(c => {
                    let update = {
                        ...c,
                        state: {
                            ...c.state,
                            [key]: {
                                ...c.state[key],
                                validating: true
                            }
                        }
                    }

                    update.validating = Object.keys(update.state).some(x => c.state[x]?.validating === true);

                    return update;
                });
            }
        }
    }, []);

    const context = useMemo(() => {
        return {
            loading: loading.loading,
            validating: loading.validating
        }
    }, [loading])

    return (
        <LoadingActionContext.Provider value={actionContext}>
            <LoadingContext.Provider value={context}>
                {children}
            </LoadingContext.Provider>
        </LoadingActionContext.Provider>
    )
}

export default LoadingProvider;